import styles from "./Settings.module.css";
import React from "react";

interface Props {
  setIsLeaveTeamModalOpen: (showLeaveTeamModal: boolean) => void;
  handleLeaveTeam: () => void;
  isLeavingTeam: boolean;
  embedded: false;
}

export default function LeaveTeamModal({
  setIsLeaveTeamModalOpen,
  handleLeaveTeam,
  isLeavingTeam,
  embedded,
}: Props) {
  const inner = (
    <div className={styles.modalContent}>
      <h2 className={styles.modalTitle}>Leave Team</h2>

      <p className={styles.modalDescription}>
        Are you sure you want to leave this team? You will no longer have access
        to team data and features.
      </p>

      <div className={styles.modalButtonContainer}>
        <button
          onClick={() => setIsLeaveTeamModalOpen(false)}
          className="proceed-button"
        >
          Cancel
        </button>

        <button
          onClick={handleLeaveTeam}
          disabled={isLeavingTeam}
          className="proceed-button"
        >
          {isLeavingTeam ? "Leaving..." : "Leave Teamsz"}
        </button>
      </div>
    </div>
  );

  if (embedded) {
    return inner;
  }

  return <div className={styles.modalOverlay}>{inner}</div>;
}
